// Components imports
import SuccessStoryComponent from "../../../shared/components/success-story/success-story.component";

import { MONITOR_SUCCESS_PROP_DATA } from "../../../shared/constants/shared.contants";

/**
 * MonitorSuccessStoryComponent is a functional component that displays a success story section with a description and an image.
 *
 * @component
 * @returns {React.JSX.Element}
 */

const MonitorSuccessStoryComponent = (): React.JSX.Element => {
    return <SuccessStoryComponent successData={MONITOR_SUCCESS_PROP_DATA} />;
};

export default MonitorSuccessStoryComponent;
